import type { PaletteMode } from '@mui/material';
import { createContext, useContext } from 'react';

export type ThemeModeContextValue = {
  partyAvailable: boolean;
  partyEnabled: boolean;
  partyBackground: string;
  setPartyEnabled: (enabled: boolean) => void;
  setPartyBackground: (color: string) => void;
  mode: PaletteMode;
  setMode: (mode: PaletteMode) => void;
  toggleMode: () => void;
};

export const ThemeModeContext = createContext<ThemeModeContextValue | undefined>(undefined);

export function useThemeMode() {
  const context = useContext(ThemeModeContext);

  if (!context) {
    throw new Error('useThemeMode must be used within the ThemeProvider');
  }

  return context;
}
